export const clearAuthData = () => {
	localStorage.removeItem('authToken')
	localStorage.removeItem('tokenType')
	localStorage.removeItem('tokenExpiration')
	localStorage.removeItem('refreshToken')
	localStorage.removeItem('username')
}

export const isTokenExpired = () => {
	const expirationTime = localStorage.getItem('tokenExpiration')
	if (!expirationTime) return false

	return Date.now() > parseInt(expirationTime, 10)
}
